var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoBrandLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70671 30.9675L29.4722 8.20205L24.3606 3.09037L1.59502 25.8558C0.714132 26.7367 0.714134 28.1649 1.59502 29.0458L3.51673 30.9675C4.39762 31.8484 5.82582 31.8484 6.70671 30.9675Z",
    fill: "url(#paint0_linear_2351_502)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70671 30.9675L29.4722 8.20205L24.3606 3.09037L1.59502 25.8558C0.714132 26.7367 0.714134 28.1649 1.59502 29.0458L3.51673 30.9675C4.39762 31.8484 5.82582 31.8484 6.70671 30.9675Z",
    fill: "url(#paint1_linear_2351_502)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03508 25.3482V12.7991H0.00692749V25.3482C0.00692749 29.2299 3.15342 32.3763 7.03508 32.3763H19.5843V25.3482H7.03508ZM24.6943 0.660934H7.03508C3.15342 0.660934 0.00692749 3.80736 0.00692749 7.68901V7.69814H24.6943V32.3763C28.576 32.3763 31.7225 29.2299 31.7225 25.3482V7.68901C31.7225 3.80736 28.576 0.660934 24.6943 0.660934Z",
    fill: "#BCBCBC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2351_502",
    x1: 1.58585,
    y1: 29.2722,
    x2: 27.8853,
    y2: 6.37485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#BCBCBC",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BCBCBC",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BCBCBC",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2351_502",
    x1: 1.58636,
    y1: 29.275,
    x2: 21.7788,
    y2: 9.08238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBCBC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoBrandLogoIcon);
export default __webpack_public_path__ + "static/media/cryptoBrandLogoIcon.bcff381508719e4d887ca29b37df6c0e.svg";
export { ForwardRef as ReactComponent };